
<template>
  <div class="with-manage">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">提现时间设置 <span style="color: #666;">（设置后，该时间段内不允许用户提现）</span> </div>
        <div class="select-container" style="margin-top: 0px;">
          <div class="select-container-box">
            <div class="item">
              <p>开始时间：</p>
               <el-date-picker
                  v-model="startTime"
                  type="datetime"
                  @change="getSTime"
                  placeholder="选择日期时间">
                </el-date-picker>
            </div>
            <div class="item">
              <p>结束时间：</p>
              <el-date-picker
                  v-model="endTime"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
            </div>
            <div class="foot flex">
              <!-- <div class="base-btn can-btn flex-center">取消</div> -->
              <div class="base-btn save-btn flex-center" @click="save">保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import Moment from "moment";
export default {
  name: "WithManage",
  data() {
    return {
      startTime: "",
      endTime: "",
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        }
      }
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    // 获取开始时间
    getSTime(val) {
      this.startTime = val;
    },
    async getData() {
      let res = await this.$api.getUnWithdrawTime();
      console.log(res.data);
      this.startTime = res.data.startTime;
      this.endTime = res.data.endTime;
    },
    async save() {
      let params = {
        startTime: Moment(this.startTime)
          .utcOffset(480)
          .format("YYYY-MM-DD HH:mm:ss"),
        endTime: Moment(this.endTime)
          .utcOffset(480)
          .format("YYYY-MM-DD HH:mm:ss")
      };
      let res = await this.$api.setUnWithdrawTime(params);
      console.log(res);
      if (res.data == "") {
        this.$message({
          message: "保存成功",
          type: "success"
        });
      }
    }
  }
};
</script>
<style lang="stylus" >
.with-manage {
  .select-container-box {
    padding-top: 100px;
  }
  .item {
    padding-left: 179px;
    margin-bottom: 72px;
    display: flex;
    align-items: center;
    p {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666;
      margin-right: 18px;
      cursor: pointer;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 384px;
      height: 56px;
      background: #fff;
      border: 1px solid #dbdcde;
      border-radius: 6px;
      padding-left: 24px;
      font-size: 22px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #333;
      display: flex;
      align-items: center;
      .el-input__inner {
        width: 100%;
        border: 0;
        font-size: 20px;
        padding-left: 20px;
        &::-webkit-input-placeholder {
          font-size: 18px;
        }
      }
    }
  }
  .foot {
    display: flex;
    padding-left: 307px;
    .base-btn {
      width: 120px;
      height: 40px;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: 1px solid #e0e0e0;
      line-height: 42px;
    }
    .can-btn {
      color: #575757;
      background-color: #fff;
      margin-right: 32px;
    }
    .save-btn {
      border-color: #3389ff;
      background-color: #3389ff;
    }
  }
  .hidden {
    display: none;
  }
}
</style>
